import React, { useEffect, useState } from 'react';
import { useGetUserProfileQuery } from '../../services';
import dayjs from 'dayjs';
import { DatePicker } from 'antd';

import QaIntegrationList from './QaIntegrationList';
import { QaIntegrationRequestDto } from '../../types';

const { RangePicker } = DatePicker;
const dateFormat = 'DD/MM/YYYY';
const DEFAULT_QA_INTEGRATION_REQUEST = {
  agent: '',
  fromDate: '',
  toDate: ''
};

const QaIntegration = () => {
  const { isLoading: profileLoading, data: profileRes } = useGetUserProfileQuery(undefined, {
    refetchOnMountOrArgChange: true
  });

  const agent = profileRes?.data.username || '';

  const [fromDate, setFromDate] = useState<string>(dayjs().subtract(3, 'month').format(dateFormat));
  const [toDate, setToDate] = useState<string>(dayjs().format(dateFormat));

  const handleDateChange = (dates: [dayjs.Dayjs | null, dayjs.Dayjs | null] | null) => {
    if (dates?.[0]) setFromDate(dates[0].format(dateFormat));
    if (dates?.[1]) setToDate(dates[1].format(dateFormat));
  };

  const [requestData, setRequestData] = useState<QaIntegrationRequestDto>({
    ...DEFAULT_QA_INTEGRATION_REQUEST,
    agent,
    fromDate,
    toDate
  });

  useEffect(() => {
    setRequestData((prev) => ({
      ...prev,
      agent,
      fromDate,
      toDate
    }));
  }, [agent, fromDate, toDate]);

  return (
    <div className={'space-y-2'}>
      <section className={'flex justify-center'}>
        <RangePicker
          value={[dayjs(fromDate, dateFormat), dayjs(toDate, dateFormat)]}
          format={dateFormat}
          onChange={handleDateChange}
        />
      </section>
      <section>
        <QaIntegrationList requestData={requestData} setRequestData={setRequestData} />
      </section>
    </div>
  );
};

export default QaIntegration;
